import React, { ReactElement } from 'react';
import { AuthContextProvider } from './contexts/auth';
import { BoardContextProvider } from './contexts/board';
import { BlockContextProvider } from './contexts/block';

interface Props {
  children: ReactElement;
}

const ContextProvider = (props: Props): ReactElement => {
  return (
    <AuthContextProvider>
      <BlockContextProvider>
        <BoardContextProvider>{props.children}</BoardContextProvider>
      </BlockContextProvider>
    </AuthContextProvider>
  );
};

export default ContextProvider;
